var _circle, _text, _circle2, _text2, _circle3, _text3, _circle4, _text4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaj7ChordA(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 83 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 20,
    r: 5,
    stroke: "black",
    strokeWidth: 1,
    fill: "rgb(256,256,256,125)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 22.5,
    y: 22,
    fontSize: "0.35em",
    textAnchor: "middle"
  }, "1")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 40,
    r: 5,
    stroke: "black",
    strokeWidth: 1,
    fill: "rgb(256,256,256,125)"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 47.5,
    y: 42,
    fontSize: "0.35em",
    textAnchor: "middle"
  }, "7")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 60,
    r: 5,
    stroke: "black",
    strokeWidth: 1,
    fill: "rgb(256,256,256,125)"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 35,
    y: 62,
    fontSize: "0.35em",
    textAnchor: "middle"
  }, "5")), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 5,
    stroke: "black",
    strokeWidth: 1,
    fill: "rgb(256,256,256,125)"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 62,
    fontSize: "0.35em",
    textAnchor: "middle"
  }, "3")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaj7ChordA);
export default __webpack_public_path__ + "static/media/Maj7ChordA.a39e70bc79fe5a229b6d95e7af845987.svg";
export { ForwardRef as ReactComponent };